module.exports = __webpack_public_path__ + "static/media/info-icon.f72312be.svg";